import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';

import { IconConnection } from '../../../Atoms/Icon';

import { getIsConnected } from './connection';
import styles from './wan.module.css';

const TabHeader = ({
  activeConnectionName,
  connectionName,
  connectionStatus,
  kpi = null,
}) => {
  return (
    <div className={styles.tabHeader}>
      <div className={classNames('justify-content-center', styles.tabHeader)}>
        <div className={styles.tabContent}>
          <IconConnection
            name={connectionName}
            isConnected={getIsConnected(connectionStatus)}
            isActive={activeConnectionName === connectionName}
            className="mr-2"
            style={{
              fontSize: getIsConnected(connectionStatus) ? '22px' : '16px',
            }}
          />

          <span className="text-uppercase">
            {connectionName.toLowerCase() === 'wifi' ? 'wi-fi' : connectionName}
          </span>
        </div>
      </div>

      {kpi !== null && (
        <div className={classNames('pr-1 text-gray', styles.kpi)}>
          {kpi.toFixed(1)}
        </div>
      )}
    </div>
  );
};

TabHeader.propTypes = {
  activeConnectionName: PropTypes.string.isRequired,
  connectionName: PropTypes.string.isRequired,
  connectionStatus: PropTypes.string,
  kpi: PropTypes.number,
};

export default TabHeader;
